import script from "./ProfessionalsDeckSpView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalsDeckSpView.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionalsDeckSpView.vue?vue&type=style&index=0&id=3347b88a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3347b88a"]])

export default __exports__